import { ResponseException } from "../../Exceptions";
import { request } from "./api";

export async function login({ username, password }) {
    const response = await request("POST /auth/login", {
        body: { username, password }
    });

    return response;
}

export async function register(data) {
    const response = await request("POST /auth/register", { body: data });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function getAccountsList(filters) {
    const response = await request("/auth/accounts", { query: filters });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function addAccount(data) {
    const response = await request("POST /auth/register-confirmed", { body: data });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function updateAccount(data) {
    const response = await request(`PATCH /auth/${data.id}`, { body: data });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function deleteAccount({ id, password }) {
    const response = await request(`DELETE /auth/${id}`, { headers: { password } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function confirmAccount({ id, password }) {
    const response = await request(`POST /auth/confirm`, { headers: { password }, query: { accountId: id } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

function serializeAccount({ fullname, username, password, role, role_specific, province, lgu }) {
    const roleToKeys = {
        get admin() { return ["root:*"] },
        get province() { return [`root.${province}:write,review,edit`] },
        get lgu() { return [`root.${province}.${lgu}:write`] },
    };

    const keys = roleToKeys[role] || [];
    const account = { fullname, username, password, role, keys };
    if(role_specific) account.role_specific = role_specific;

    return account;
}

export async function logout() {
    await request("POST /auth/logout");
}